"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UIIconHolder = _interopRequireDefault(require("./UIIconHolder"));

var _default = _react.default.createClass({
  displayName: "UIIconCircle",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    backgroundColor: _UIIconHolder.default.propTypes.backgroundColor,
    borderColor: _UIIconHolder.default.propTypes.borderColor,
    borderStyle: _UIIconHolder.default.propTypes.borderStyle,
    borderWidth: _UIIconHolder.default.propTypes.borderWidth,
    verticalAlign: _UIIconHolder.default.propTypes.verticalAlign,
    innerStyles: _react.PropTypes.object,
    iconClassName: _react.PropTypes.string,
    name: _UIIconHolder.default.propTypes.name,
    color: _react.PropTypes.string,
    size: _react.PropTypes.number,
    padding: _react.PropTypes.number,
    legacy: _react.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      borderWidth: 1,
      borderStyle: 'solid',
      padding: 0.75
    };
  },
  getBorderColor: function getBorderColor(borderColor, color) {
    if (borderColor) {
      return borderColor;
    }

    return color;
  },
  getPadding: function getPadding(padding, legacy) {
    return legacy ? 0 : padding;
  },
  render: function render() {
    var _this$props = this.props,
        backgroundColor = _this$props.backgroundColor,
        borderColor = _this$props.borderColor,
        borderStyle = _this$props.borderStyle,
        borderWidth = _this$props.borderWidth,
        className = _this$props.className,
        color = _this$props.color,
        iconClassName = _this$props.iconClassName,
        innerStyles = _this$props.innerStyles,
        legacy = _this$props.legacy,
        name = _this$props.name,
        padding = _this$props.padding,
        size = _this$props.size,
        style = _this$props.style,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["backgroundColor", "borderColor", "borderStyle", "borderWidth", "className", "color", "iconClassName", "innerStyles", "legacy", "name", "padding", "size", "style"]);
    var outerCircleClassNames = (0, _classNames.default)('private-icon-circle__outer', {
      'private-icon-circle--legacy': legacy
    }, className);
    var innerCircleClassNames = (0, _classNames.default)('private-icon-circle__inner', iconClassName);
    return _react.default.createElement(_UIIconHolder.default, (0, _extends2.default)({}, rest, {
      backgroundColor: backgroundColor,
      borderColor: this.getBorderColor(borderColor, color),
      borderRadius: "50%",
      borderStyle: borderStyle,
      borderWidth: borderWidth,
      className: outerCircleClassNames,
      innerClassName: innerCircleClassNames,
      size: size,
      padding: this.getPadding(padding, legacy),
      name: name,
      color: color,
      style: style,
      innerStyles: innerStyles,
      _fromUIIconCircle: true
    }));
  }
});

exports.default = _default;
module.exports = exports.default;